import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import toast from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { RequestCriarProcessoJudicialHistorico } from "types/request/RequestCriarProcessoJudicialHistorico";

export const usePostCriarProcessoJudicialHistorico = () => {
  const onSuccess = () => {
    queryClient.invalidateQueries(["processos-judiciais-historicos"]);
    queryClient.invalidateQueries(["processos-judiciais"]);
    toast.success("Histórico salvo com sucesso.");
  };

  return usePost<RequestCriarProcessoJudicialHistorico>({
    url: api.processosJudiciaisHistorico.postProcessoJudicialHistorico,
    onSuccess,
  });
};
